<template>
    <div v-route-title="'角色管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">角色管理</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">新建角色</el-button>
                </div>
            </div>
            <el-form class="search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="角色ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="角色名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="角色名称">
                    </el-table-column>
                    <el-table-column
                            label="创建时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户">
                        <span slot-scope="scope">{{scope.row.creator?scope.row.creator.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户">
                        <span slot-scope="scope">{{scope.row.editor?scope.row.editor.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="210">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-edit" @click="editRoleGrants(scope.row)">授权</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改角色':'新建角色'" :visible.sync="dialogFormVisible" label>
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="grantModel" title="修改角色权限" :visible.sync="grantDialogVisible" label width="650px">
            <el-tabs class="yq-role-grant-tabs" v-model="grantTab">
                <el-tab-pane label="功能权限" name="permission">
                    <div class="yq-role-grant-permissions">
                        <el-checkbox v-for="item in grantModel.permissions" :key="item.id" v-model="item.granted">
                            {{item.operation + item.object}}
                        </el-checkbox>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="门户查看权限" name="portal" v-if="hasAuthority('T_前台用户')">
                    <el-tree ref="portalTree" node-key="key" :default-checked-keys="grantModel.defaultCheckedKeys"
                             :data="grantModel.portalTree" :props="treeProps"
                             default-expand-all show-checkbox check-strictly
                             @check="handleCheck" @check-change="handleCheckChange"></el-tree>
                </el-tab-pane>
                <el-tab-pane label="数据源编审权限" name="datasource">
                    <div class="yq-role-grant-datasources">
                        <el-checkbox v-for="item in grantModel.datasources" :key="item.id" v-model="item.granted">
                            {{item.name}}
                        </el-checkbox>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="grantDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitGrantForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userService from '../service/user'
    import roleService from '../service/role'
    import portalService from '../service/portal'
    import {mapGetters} from 'vuex'

    export default {
        name: "RoleAdmin",
        data() {
            const checkName = (rule, value, callback) => {
                if (value) {
                    roleService.checkRoleName(value).then(response => {
                        if (response.data && this.model.id !== response.data.id) {
                            callback(new Error('该角色已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            return {
                searchModel: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                data: null,
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ]
                },
                treeProps: {
                    children: 'children',
                    label: 'name'
                },
                grantDialogVisible: false,
                grantTab: 'permission',
                grantModel: null
            }
        },
        created(){
            this.fetchData(1)
        },
        computed: {
            ...mapGetters(['hasAuthority', 'hasAnyAuthority'])
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await roleService.listRoles(params)
                await userService.fetchCreatorAndEditor(response.data.content)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow(){
                this.model = {
                    name: null
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                if (row.fixed) {
                    this.$message({
                        type: 'error',
                        message: '无法修改内置角色!'
                    })
                    return
                }
                roleService.getRole(row.id).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        roleService.updateRole({
                            id: this.model.id,
                            data: this.model
                        }).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        roleService.addRole(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            editRoleGrants(row) {
                if (row.fixed) {
                    this.$message({
                        type: 'error',
                        message: '无法修改内置角色的权限!'
                    })
                    return
                }
                roleService.getRoleGrants(row.id).then(response => {
                    if(response.data.portals){
                        const portalTree = []
                        const defaultCheckedKeys = []
                        for(const portal of response.data.portals){
                            portal.key = 'portal' + portal.id
                            portal.children = portalService.buildPortalPageTree(portal.pages)
                            portal.pages.forEach(item => {
                                item.key = 'page' + item.id
                                if(item.granted){
                                    defaultCheckedKeys.push(item.key)
                                }
                            })
                            portalTree.push(portal)
                            if(portal.granted){
                                defaultCheckedKeys.push(portal.key)
                            }
                        }
                        response.data.defaultCheckedKeys=defaultCheckedKeys
                        response.data.portalTree = portalTree;
                    }
                    this.grantModel = response.data
                    this.grantDialogVisible = true
                })
            },
            handleCheck(data){
                const currentNode = this.$refs.portalTree.getNode(data)
                const checked = currentNode.checked
                if(checked){
                    // 选中所有父级节点
                    let node = this.$refs.portalTree.getNode(data).parent
                    while(node){
                        if(!node.checked){
                            this.$refs.portalTree.setChecked(node.data, true)
                        }
                        node = node.parent
                    }
                }
                //  关联所有子孙节点
                const stack = [...currentNode.childNodes]
                while(stack.length>0){
                    const node = stack.shift()
                    this.$refs.portalTree.setChecked(node.data, checked)
                    stack.push(...node.childNodes)
                }
            },
            handleCheckChange(data, checked){
                data.granted = checked
            },
            submitGrantForm() {
                const mapper = item => {
                    return {
                        id: item.id,
                        granted: item.granted
                    }
                }
                const data = {
                    permissions: this.grantModel.permissions ? this.grantModel.permissions.map(mapper) : [],
                    portals: this.grantModel.portals ? this.grantModel.portals.map(portal => {
                        return {
                            id: portal.id,
                            granted: portal.granted,
                            pages: portal.pages.map(mapper)
                        }
                    }) : null,
                    datasources: this.grantModel.datasources ? this.grantModel.datasources.map(mapper) : null
                }
                roleService.updateRoleGrants(this.grantModel.id, data).then(() => {
                    this.grantDialogVisible = false
                    this.$message({
                        type: 'success',
                        message: '修改角色权限成功!'
                    })
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '修改角色权限失败!'
                    })
                })
            },
            deleteRow(row){
                if (row.fixed) {
                    this.$message({
                        type: 'error',
                        message: '无法删除内置角色!'
                    })
                    return
                }
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    roleService.deleteRole(row.id).then(()=>{
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number>0?this.data.number:1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>
<style scoped>
    .el-transfer-role-permissions >>> .el-transfer-panel{
        width: 210px;
    }
    .yq-role-grant-tabs >>> .el-tabs__content{
        height: 300px;
        overflow: auto;
    }
    .yq-role-grant-permissions,.yq-role-grant-datasources{
        display: flex;
        flex-direction: column;
    }
    .yq-role-grant-permissions > .el-checkbox,.yq-role-grant-datasources > .el-checkbox{
        margin: 10px 0;
    }
</style>
